import {
	SET_STORAGES,
	SET_STORAGE,
	CLEAR_STORAGES,
	CLEAR_STORAGE,
	ADD_STORAGE,
	UPDATE_STORAGE,
	REMOVE_STORAGE,
} from './actionTypes';

export const storage = (state = {}, action) => {
	switch (action.type) {
		case SET_STORAGE:
			return action.payload;
		case UPDATE_STORAGE:
			if (state._id.toString() !== action.payload._id.toString()) {
				return state;
			}

			// Otherwise, this is the one we want - return an updated value
			return {
				...state,
				...action.payload,
			};
		case CLEAR_STORAGE:
			return {};
		default:
			return state;
	}
};

export default (state = [], action) => {
	switch (action.type) {
		case SET_STORAGES:
			return action.payload;
		case ADD_STORAGE:
			return [...state, action.payload];
		case UPDATE_STORAGE:
			return state.map((item) => {
				if (item._id !== action.payload._id) {
					return item;
				}

				// Otherwise, this is the one we want - return an updated value
				return {
					...item,
					...action.payload,
				};
			});
		case REMOVE_STORAGE:
			return state.map((item) => {
				if (item._id !== action.payload._id) {
					return item;
				}

				// Otherwise, this is the one we want - return an updated value
				return {
					...item,
				};
			});
		case CLEAR_STORAGES:
			return [];
		default:
			return state;
	}
};
